import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { DropdownButton } from 'react-bootstrap';
import * as insight360Actions from '../../actions/insight360Actions';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import { getStudyFamiliesFromStudies } from '../../util/CommonUtils';

class PreferencesCommonStudyFamilySelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      studyFamilies: [],
      // style: {},
      ddListVisible: false,
      selectedStudyFamily: undefined,
    };
  }

  componentDidMount() {
    const { menuName, dbKey } = this.props.field;
    let defaultval = this.getKeyData(dbKey);
    defaultval = defaultval !== undefined ? defaultval : -1;
    this.getStudiesForModule(menuName, defaultval);
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.bcStudies && this.props.field.menuName === 'BrandCatalyst') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
    }

    if (nextProps.scStudies && this.props.field.menuName === 'SalesCatalyst') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
    }
  }

  getKeyData = (key, defaultData, newData) => {
    const { modifiedPreferences, userPreference } = this.props;
    const keys = key.split('.');
    let dataKey;
    if (newData !== undefined) {
      dataKey = newData;
    } else {
      dataKey = defaultData ? userPreference : modifiedPreferences;
    }
    return !_.isEmpty(dataKey) ? dataKey[keys[0]][keys[1]] : undefined;
  }

  getStudiesForModule = (activeModule, defaultValue) => {
    switch (activeModule) {
      case 'BrandCatalyst': {
        let studyFamilies = [];
        let selectedStudyFamily;
        if (this.props.bcStudies && this.props.bcStudies.length > 0) {
          studyFamilies = getStudyFamiliesFromStudies(this.props.bcStudies);
          const studyFamilyId = defaultValue === 1 ? this.getFirstStudyFamilyId(this.props.bcStudies) : defaultValue;
          selectedStudyFamily = this.getSelectedStudyFamilyForGivenId(studyFamilies, studyFamilyId);
          this.setState(() => ({
            studyFamilies,
            // style: this.props.field.style,
            selectedStudyFamily,
          }));
          if (defaultValue === 1) {
            this.updatePreferences(selectedStudyFamily);
          }
        } else {
          this.props.insight360Actions.get360Study(
            this.props.loginResponse.data.token,
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
          );
        }
        break;
      }
      case 'SalesCatalyst': {
        let studyFamilies = [];
        let selectedStudyFamily;
        if (this.props.scStudies && this.props.scStudies.length > 0) {
          studyFamilies = getStudyFamiliesFromStudies(this.props.scStudies);
          const studyFamilyId = defaultValue === 1 ? this.getFirstStudyFamilyId(this.props.scStudies) : defaultValue;
          selectedStudyFamily = this.getSelectedStudyFamilyForGivenId(studyFamilies, studyFamilyId);
          this.setState(() => ({
            studyFamilies,
            // style: this.props.field.style,
            selectedStudyFamily,
          }));
          if (defaultValue === 1) {
            this.updatePreferences(selectedStudyFamily);
          }
        } else {
          this.props.salesCatalystActions.getsalesCatalystStudy(
            this.props.loginResponse.data.token,
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
          );
        }
        break;
      }
      default:
        break;
    }
  }

  getFirstStudyFamilyId = studies => {
    return studies[0].id;
  }

  getSelectedStudyFamilyForGivenId = (studyFamilies, id) => {
    let studyFamilyId = id;
    if (id === -1) {
      studyFamilyId = studyFamilies[0].id;
    }
    let selectedStudyFamily = _.find(studyFamilies, { id: studyFamilyId });
    selectedStudyFamily = selectedStudyFamily === undefined ? studyFamilies[0] : selectedStudyFamily;
    return selectedStudyFamily;
  }

  updatePreferenceStudyForModule = (nextProps, menuName) => {
    if (menuName === 'BrandCatalyst') {
      let selectedStudyFamily;
      let studyFamilies = [];
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._bc._sf !== -1) {
        studyFamilies = getStudyFamiliesFromStudies(nextProps.bcStudies);
        selectedStudyFamily = this.getSelectedStudyFamilyForGivenId(studyFamilies, nextProps.userPreference._bc._sf);
      } else {
        studyFamilies = getStudyFamiliesFromStudies(nextProps.bcStudies);
        selectedStudyFamily = studyFamilies[0];
      }
      this.setState(() => ({
        studyFamilies,
        // style: this.props.field.style,
        selectedStudyFamily,
      }));
    } else if (menuName === 'SalesCatalyst') {
      let selectedStudyFamily;
      let studyFamilies = [];
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._sc._sf !== -1) {
        studyFamilies = getStudyFamiliesFromStudies(nextProps.scStudies);
        selectedStudyFamily = this.getSelectedStudyFamilyForGivenId(studyFamilies, nextProps.userPreference._sc._sf);
      } else {
        studyFamilies = getStudyFamiliesFromStudies(nextProps.scStudies);
        selectedStudyFamily = studyFamilies[0];
      }
      this.setState(() => ({
        studyFamilies,
        // style: this.props.field.style,
        selectedStudyFamily,
      }));
    }
  }

  updatePreferences = selectedStudyFamily => {
    this.props.updatePreferences(
      this.props.field.dbKey,
      selectedStudyFamily.id,
    );
  }

  itemClick = item => {
    const curSelectedItem = this.state.selectedStudyFamily;
    if (!_.isEqual(item, curSelectedItem)) {
      this.setState({
        ddListVisible: false,
        selectedStudyFamily: item,
      });
      this.updatePreferences(item);
    } else {
      this.setState({
        ddListVisible: false,
      });
    }
  }

  render() {
    return (
      <div className="common-select-dropdown">
        <DropdownButton
          className={this.state.selectedStudyFamily === undefined && 'place-holder'}
          title={this.state.selectedStudyFamily !== undefined ? this.state.selectedStudyFamily.desc : ''}
          id="selectStudyFamily"
          show={this.state.ddListVisible}
          onToggle={() =>
            this.setState(prevState => ({
              ddListVisible: !prevState.ddListVisible,
            }))
          }
        >
          <li>
            {this.state.studyFamilies.length > 0 ? <ul className="menu-list">
              {_.map(this.state.studyFamilies, o => (
                o.desc !== undefined && <li
                  key={o.id}
                  onClick={() => this.itemClick(o)}
                >{o.desc}</li>
              ))}
            </ul> : (
              <span className="display-block padding-10">
                Loading...
              </span>
            )}
          </li>
        </DropdownButton>
      </div>
    );
  }
}

PreferencesCommonStudyFamilySelector.propTypes = {
  field: PropTypes.shape({
    menuName: PropTypes.string,
    style: PropTypes.shape({}),
    defaultValue: PropTypes.number,
    dbKey: PropTypes.string,
  }),
  salesCatalystActions: PropTypes.shape({
    getsalesCatalystStudy: PropTypes.func,
  }),
  insight360Actions: PropTypes.shape({
    get360Study: PropTypes.func,
  }),
  bcStudies: PropTypes.arrayOf(PropTypes.shape({})),
  scStudies: PropTypes.arrayOf(PropTypes.shape({})),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  updatePreferences: PropTypes.func,
  userPreference: PropTypes.shape({}),
  modifiedPreferences: PropTypes.shape({}),
  // preferenceStudyFamilyChangedFn: PropTypes.func,
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    bcStudies: state.study.insight360studies,
    scStudies: state.study.salesCatalystStudies,
    userPreference: state.preferences.userPreferences,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(PreferencesCommonStudyFamilySelector);
